import { userConstants } from '../constants/user.constants';

let token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : null;
let me = localStorage.getItem('me') ? JSON.parse(localStorage.getItem('me')) : null;
const initialState = token ? { loggedIn: true, token, me } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}
